import { Card } from '@mui/material'
import { styled } from '@mui/material'

export const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: Number(theme.shape.borderRadius) * 2,
  '&:hover': {
    boxShadow: theme.shadows[6]
  }
}))
